module.exports = __webpack_public_path__ + "static/media/morning.282140a8.png";